<template>
  <Row>
    <i-col span="12">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="集团名称" prop="name">
          <i-input v-model="formValidate.name" placeholder="请输入角色名称"></i-input>
        </FormItem>
        <FormItem label="集团类型" prop="type">
          <Select v-model="formValidate.type" style="width:260px">
            <Option v-for="item in companytype" :value="item.type" :key="item.type">{{ item.value }}</Option>
          </Select>
        </FormItem>
        <FormItem label="佣金比例" prop="union_distribution_rate">
          <InputNumber
            :max="100"
            v-model="formValidate.union_distribution_rate"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
          ></InputNumber>
        </FormItem>
        <FormItem label="审核状态" prop="examine">
          <RadioGroup v-model="formValidate.examine">
            <Radio label="1">通过</Radio>
            <Radio label="0">未通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
          <!-- <Button type="ghost" @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button> -->
        </FormItem>
      </Form>
    </i-col>
    <i-col span="12"></i-col>
  </Row>
</template>
<script>
import { mapState } from "vuex";
import { updatecompany } from "../../api/companyapi";
import constantdata from "../../constant/index";
export default {
  data() {
    const validatetype = (rule, value, callback) => {
      if (value === "" && this.typestate == true) {
        callback(new Error("请选择集团类型"));
      } else {
        callback();
      }
    };
    const validaterate = (rule, value, callback) => {
      if (value < 1) {
        callback(new Error("请输入佣金比例"));
      } else {
        callback();
      }
    };
    return {
      formValidate: {
        name: "",
        type: "",
        examine: "",
        union_distribution_rate: 0
      },
      param: this.$route.query,
      typestate: true, //集团类型判断
      companytype: constantdata.companytype,
      labelInValue: true,
      ruleValidate: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        type: [
          {
            validator: validatetype,
            message: "请选择集团类型",
            trigger: "change"
          }
        ],
        union_distribution_rate: [
          {
            validator: validaterate,
            message: "请输入佣金比例",
            trigger: "blur"
          }
          // { required: true, message: "请输入佣金比例", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.typestate = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.updatecompany();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    updatecompany() {
      this.typestate = false;
      var para = {
        name: this.formValidate.name,
        type: this.formValidate.type == "1" ? 1 : 0,
        examine: this.formValidate.examine == "1" ? 1 : 0,
        id: this.param.id,
        union_distribution_rate: this.formValidate.union_distribution_rate / 100
      };
      this.$Loading.start();
      updatecompany(para).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          var _this = this;
          setTimeout(function() {
            _this.$router.push({ path: "/Companylist" });
          }, 1500);
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    init(param) {
      this.formValidate = {
        name: param.name,
        type: param.type,
        examine: param.examine + "",
        union_distribution_rate: param.union_distribution_rate * 100
      };
    }
  },
  mounted() {
    if (this.$route && this.$route.query) {
      this.init(this.$route.query);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/company/updte.vue